import { render } from "./BottomNavigation.vue?vue&type=template&id=275738a5&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=275738a5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-275738a5"

export default script